import { jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';
import toast from 'react-hot-toast';

export async function getCsvString(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/intlcsv`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });

    return await response.json();
}

export async function loadCsvFile(body, authHeaders) {
    const response = await fetch(`${API_URL}/p/intlcsv`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify({ body })
    });

    return await response.json();
}

export default function useIntlCsv({ setIsUpdatingText, setIsDownloadingCSVFile }) {
    const { data, refetch, ...flags } = useAuthQuery({
        queryKey: ['downloadcsv'],
        queryFn: getCsvString,
        refetchOnWindowFocus: false,
        enabled: false,
        onError: () => {
            setIsDownloadingCSVFile(false);
            console.error('Server Error');
        }
    });

    const upload = useAuthMutation({
        mutationFn: loadCsvFile,
        mutationKey: ['uploadcsv'],
        onSuccess: (res) => {
            res.ok ? toast.success(_t.intl.save()) : toast.error(res.errorText);
            setIsUpdatingText(false);
        },
        onError: (e) => {
            console.error('Server Error');
            setIsUpdatingText(false);
        }
    });

    return { csv: data?.csv, download: refetch, flags, upload };
}
